import { ca } from '@cian/analytics';

export function trackProjectListShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Scroll',
    label: 'home_projects',
  });
}

export function trackToggleProjectListVisibility(isHidden: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click',
    label: isHidden ? 'close_home_projects' : 'open_home_projects',
  });
}

export function trackProjectListItemClick(id: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click',
    label: `home_projects/${id}`,
  });
}
